import axios from 'axios';

const baseUrl = () => {
  if (process.env.NODE_ENV !== 'development') {    
    return 'https://api.fynd.com.br'
  } else {
    return 'http://localhost:3001'
  }
}

const http = axios.create({ baseURL: baseUrl(), timeout: 20000});

export default http;